import { Select as BaseSelect } from 'antd';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  padding: 20px 0 25px 0;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;

  nav li {
    display: flex;
    align-items: center;
  }
`;

export const Select = styled(BaseSelect)`
  width: 130px;

  .ant-select-selector {
    padding-left: 0 !important;
    font-size: 20px;
    color: #0046FF;
  }

  .ant-select-arrow {
    color: #0046FF;
    font-size: 16px;
  }
`;

export const Divider = styled.div`
  height: 20px;
  width: 1px;
  background-color: #1E1E1E;
  opacity: 0.3;
  margin-right: 10px;
`;


const clickableStyle = css`
  cursor: pointer;
  color: #0046FF;
  padding: 0 4px;

  &:hover {
    color: rgba(0, 0, 0, 0.88);
    background-color: rgba(0, 0, 0, 0.06);
  }
`;
export const Title = styled.div<{clickable?: boolean}>`
  color: #4A4A4A;
  font-size: 20px;
  ${props => props.clickable ? clickableStyle : ''}
`;